export default function Hero() {
  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleDownloadResume = () => {
    const resumeUrl = 'https://static.readdy.ai/image/76ac0dfda90dbfd8fe4bf81d25f81847/a75ebb80dcacf5873edc2f295764e4ff.png';
    
    // Download the resume as PDF
    const link = document.createElement('a');
    link.href = resumeUrl;
    link.download = 'Rangababu_Resume.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="home" className="min-h-screen flex items-center pt-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="space-y-4">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
                Hi, I'm <span className="text-blue-600">Rangababu</span> — Senior UX/UI Designer
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                I design user-centered digital experiences that simplify complex systems. With 12+ years of experience crafting intuitive solutions for health, medical, construction, QMS, and asset management applications.
              </p>
            </div>
            
            <div className="flex flex-wrap gap-3">
              <span className="px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium whitespace-nowrap">Enterprise UX</span>
              <span className="px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-medium whitespace-nowrap">Interaction Design</span>
              <span className="px-4 py-2 bg-gray-200 text-gray-700 rounded-full text-sm font-medium whitespace-nowrap">Product Thinking</span>
            </div>

            <div className="flex gap-4 pt-4">
              <button onClick={scrollToProjects} className="bg-blue-600 text-white px-8 py-3 rounded-full hover:bg-blue-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap font-medium">
                View My Work
              </button>
              <button onClick={handleDownloadResume} className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-full hover:bg-blue-600 hover:text-white transition-all cursor-pointer whitespace-nowrap font-medium">
                Download Resume
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl bg-gray-900">
              <iframe 
                className="w-full h-full"
                src="https://www.youtube.com/embed/ukep-shVTjY?autoplay=1&mute=1&loop=1&playlist=ukep-shVTjY"
                title="Rangababu Portfolio Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-teal-500 rounded-full opacity-20 blur-3xl"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-blue-500 rounded-full opacity-20 blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
